/**
 * Toast hook wrapper for easier consumption
 */
import { useToastStore } from '@/components/ui/Toast'

export function useToast() {
  const add = useToastStore((s) => s.add)

  return {
    showToast: (opts: { type: 'success' | 'error' | 'warning' | 'default'; message: string; description?: string }) => {
      add({
        title: opts.message,
        description: opts.description,
        variant: opts.type === 'default' ? 'default' : opts.type,
      })
    },
    success: (title: string, description?: string) =>
      add({ title, description, variant: 'success' }),
    error: (title: string, description?: string) =>
      add({ title, description, variant: 'error' }),
    warning: (title: string, description?: string) =>
      add({ title, description, variant: 'warning' }),
  }
}
